import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { getApiData } from "../helpers/AxiosInstance";

interface IUseGetHook {
  queryKey: (string | number)[];
  url: string;
  params?: any;
  interval?: number;
  enabled?: boolean;
}

const useGetAccount = ({
  queryKey,
  url,
  params = {},
  interval,
  enabled = true,
}: IUseGetHook) => {
  const query = useQuery({
    queryKey, // 🔥 DO NOT auto-append params here
    queryFn: async () => {
      if (!enabled) return null; // 🛑 hard stop safety
      const response = await getApiData(url, params);
      return response.data;
    },
    enabled,
    refetchOnWindowFocus: true,
    refetchInterval: interval ?? false,
    refetchIntervalInBackground: false,
    placeholderData: keepPreviousData,
  });

  return query;
};

export default useGetAccount;
